exports.components = {
  "component---src-pages-404-jsx": () => import("./../../../src/pages/404.jsx" /* webpackChunkName: "component---src-pages-404-jsx" */),
  "component---src-pages-preview-tsx": () => import("./../../../src/pages/preview.tsx" /* webpackChunkName: "component---src-pages-preview-tsx" */),
  "component---src-templates-content-page-tsx": () => import("./../../../src/templates/contentPage.tsx" /* webpackChunkName: "component---src-templates-content-page-tsx" */)
}

